import cn from "classnames";
import { useContext, useEffect } from "react";
import { useOverlayTriggerState } from "react-stately";

//Components
import Popup from "./Popup/Popup";

//SCSS
import "./ErrorModal.scss";

import {
  Dialog,
  ModalPortal,
} from "@evidenceb/athena-common/design-system/Modal";
//Interfaces
import { errorStore } from "../../contexts/ErrorContext";

const ErrorModal = () => {
  //States
  const { errorInfo, setErrorInfo } = useContext(errorStore);
  const state = useOverlayTriggerState({});

  const closeModal = () => setErrorInfo({ displayModal: false });

  useEffect(() => {
    if (errorInfo.displayModal) state.open();

    if (errorInfo.modal?.timeout) {
      setTimeout(() => {
        window.location.reload();
      }, errorInfo.modal?.timeout);
    }
  }, [errorInfo, state]);

  if (!state.isOpen || !errorInfo.modal) return <></>;

  const { type, content, isDismissable, onClick, onClose } = errorInfo.modal;

  return (
    <ModalPortal
      state={state}
      isDismissable={isDismissable !== undefined ? isDismissable : true}
      onClose={onClose ? onClose : closeModal}
    >
      <Dialog
        role="alertdialog"
        title={{
          as: "h3",
          content: content.title,
          className: "error-modal__title",
        }}
        aria-label="error-modal"
        onClose={onClose ? onClose : closeModal}
        className={cn("error-modal__dialog", {
          "error-modal__dialog--notification": type === "NOTIFICATION",
          "error-modal__title--no-content": !content.text && !content.btn,
        })}
        absoluteCloseBtn
      >
        {type === "POPUP" && (
          <Popup content={content} action={onClick} close={closeModal} />
        )}
      </Dialog>
    </ModalPortal>
  );
};

export default ErrorModal;
